import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'

import ConfirmDiscardDialog from '../ConfirmDiscardDialog'
import CreateRentalLiabilityForm from './Form'
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure
} from '@chakra-ui/react'

CreateRentalLiabilityModal.propTypes = {
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onSuccess: PropTypes.func,
  rentalId: PropTypes.string.isRequired
}

export default function CreateRentalLiabilityModal({
  close,
  isOpen,
  onSuccess,
  rentalId,
  occupancyDate
}: {
  close: () => void
  isOpen: boolean
  onSuccess?: (createdLiabilityIds?: string[]) => void | Promise<void>
  rentalId: string
  occupancyDate: string
}) {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  const discardCancelRef = useRef<HTMLButtonElement | null>(null)
  const discardConfirmation = useDisclosure()

  const requestClose = () => {
    if (hasUnsavedChanges) {
      discardConfirmation.onOpen()
      return
    }

    close()
  }

  const discardAndClose = () => {
    discardConfirmation.onClose()
    setHasUnsavedChanges(false)
    close()
  }

  const submitAndClose = (createdLiabilityIds: string[]) => {
    setHasUnsavedChanges(false)
    close()

    Promise.resolve(onSuccess?.(createdLiabilityIds)).catch((error) => {
      console.error('Unable to refresh ledger after creating rental liability', error)
    })
  }

  return (
    <>
      <Modal size='4xl' isOpen={isOpen} onClose={requestClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Create Rental Liability</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={7}>
            <CreateRentalLiabilityForm
              onSubmit={submitAndClose}
              onCancel={requestClose}
              onDirtyChange={setHasUnsavedChanges}
              rentalId={rentalId}
              occupancyDate={occupancyDate}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
      <ConfirmDiscardDialog
        cancelRef={discardCancelRef}
        isOpen={discardConfirmation.isOpen}
        onClose={discardConfirmation.onClose}
        onDiscard={discardAndClose}
        resourceLabel='liability'
      />
    </>
  )
}
